export enum ContractStatus {
    ACTIVE = "active",
    PENDING = "pending",
    EXPIRED = "expired",
    TERMINATED = "terminated",
}

export const CONTRACT_STATUSES = Object.values(ContractStatus)
